// extracted by mini-css-extract-plugin
export var button = "button-module--button--7e9dc";
export var danger = "button-module--danger--28366";
export var fill = "button-module--fill--cf99d";
export var primary = "button-module--primary--ec748";
export var rounded = "button-module--rounded--ca84e";
export var secondary = "button-module--secondary--b9bd7";
export var square = "button-module--square--36517";